export const PLACEHOLDER_CARD_NUMBER = 4
